import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CONSULTATION_TITRES_PAGE,
  ROOT_PAGE,
} from "../constants/routerConstants";

const withTokenValidation = (Component) => {
  return (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [alreadyNavigated, setAlreadyNavigated] = useState(false);

    useEffect(() => {
      if (location.pathname.startsWith("/reset-password")) {
        return;
      }

      const checkTokenExpiration = async () => {
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000;
          if (decodedToken.exp < currentTime) {
            localStorage.removeItem("token");
            if (!alreadyNavigated) {
              navigate(ROOT_PAGE);
              setAlreadyNavigated(true);
            }
          } else {
            if (location.pathname === "/") {
              navigate(CONSULTATION_TITRES_PAGE);
            }
          }
        } else {
          navigate(ROOT_PAGE);
        }
      };

      checkTokenExpiration();
    }, [dispatch, navigate, alreadyNavigated]);

    return <Component {...props} />;
  };
};

export default withTokenValidation;
